// extracted by mini-css-extract-plugin
module.exports = {"portal":"portal_portal__THyC9","body":"portal_body__o0lOT"};